module.exports = __webpack_public_path__ + "static/media/image4.97018004.jpg";